import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { get } from 'lodash'
import { Select } from '@driftt/tide-core-legacy'
import createFilterOptions from 'react-select-fast-filter-options'
import { getChanges } from 'components/Customize/OrgSettings/Helpers'

import { MOST_POPULATED_TIMEZONES, getOptionForTimezone, getCurrentTimezoneOption, getAllTimezoneOptions } from './utils'
import { updateOrg } from 'app/modules/org/actions'
import { patchEmbed } from 'app/modules/embed/actions'

import style from './style.styl'

class TimezonePicker extends Component {

  constructor(props) {
    super(props)

    this.state = {
      timezoneOptions: getAllTimezoneOptions(),
      filteredTimezoneOptions:[getCurrentTimezoneOption(), ...MOST_POPULATED_TIMEZONES],
      selectedTimezone: this.getThemeTimezone(),
    }
  }

  getThemeTimezone = () => {
    return get(this.props, 'orgSettings.theme.timezone', null)
  }

  onTimezoneChanged = (option) => {
    const value = !!option ? option.value : null
    this.updateTimezone(value)
  }

  updateTimezone = (timezone) => {
    if (timezone !== null) {
      const initialSettings = this.props.orgSettings
      const updatedSettings = this.updateOrgSettingsWithTimezone(timezone)
      const changes = getChanges(updatedSettings, initialSettings)

      this.props.actions.updateOrg(updatedSettings.toJS())
      this.props.actions.patchEmbed(changes)
    }

    this.setState({ selectedTimezone: timezone })
  }

  updateOrgSettingsWithTimezone = (timezone) => {
    const { orgSettings } = this.props

    return orgSettings.setIn(['theme', 'timezone'], timezone)
  }

  render() {
    const { selectedTimezone, timezoneOptions, filteredTimezoneOptions } = this.state
    const selectedOption = !!selectedTimezone ? getOptionForTimezone(selectedTimezone) : null
    const filterOptions = createFilterOptions({
      indexes: ['label', 'value'],
      options: timezoneOptions
    })

    return (
        <Select
          size="large"
          value={selectedOption}
          options={filteredTimezoneOptions}
          className="timezone-picker--select"
          filterOptions={filterOptions}
          onChange={this.onTimezoneChanged}
        />
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      updateOrg,
      patchEmbed
    },
    dispatch
  ),
})

export default connect(null, mapDispatchToProps)(TimezonePicker)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/HoursAndTargeting/TimezonePicker/index.js